export const dataHooks = {
  // Footer component hooks
  dsBuilderFooter: 'ds-builder-footer',
  dsBuilderFooterBackButton: 'ds-builder-footer-back-button',
  dsBuilderFooterNextButton: 'ds-builder-footer-next-button',
};
